// GENERATED FILE — DO NOT EDIT. `python3 tools/reviewer-week-vocab/generate.py` (repo root).
// Source: `reviewer_week_vocabulary()` in supabase/migrations/20261010230000_reviewer_week_proposals.sql — the ONE
// vocabulary of a week tree (reviewer_week's output = a reviewer's proposed week). `reviewerWeekVocabulary.test.ts`
// re-reads the migration and fails on any drift; the phone's reader (step 3) is generated from the same literal.

export const WEEK_VOCABULARY = {
  "day": {
    "id": "uuid",
    "scheduled_date": "date",
    "day_position": "int",
    "is_deload": "bool",
    "status": "text",
    "note": "text",
    "coach_workouts": "@workout"
  },
  "workout": {
    "id": "uuid",
    "name": "name",
    "description": "text",
    "kind": "text",
    "coach_workout_sections": "[]section"
  },
  "section": {
    "position": "int",
    "name": "text",
    "section_type": "text",
    "format": "text",
    "format_config": "object",
    "description": "text",
    "coach_workout_exercises": "[]exercise"
  },
  "exercise": {
    "id": "uuid",
    "position": "int",
    "exercise_id": "uuid",
    "name": "name",
    "tracking_fields": "texts",
    "sets": "int",
    "reps_min": "int",
    "reps_max": "int",
    "hold_seconds_min": "int",
    "hold_seconds_max": "int",
    "rest_seconds": "int",
    "tempo": "text",
    "notes": "text",
    "each_side": "bool",
    "superset_with_next": "bool",
    "hold_until_lost": "bool",
    "coach_workout_sets": "[]set"
  },
  "set": {
    "position": "int",
    "set_type": "text",
    "reps": "int",
    "weight_kg": "num",
    "time_seconds": "int",
    "rounds": "int",
    "distance_m": "num",
    "rest_seconds": "int"
  }
} as const;

export type WeekLevel = keyof typeof WEEK_VOCABULARY;

export type WeekDay = {
  id: string | null;
  scheduled_date: string;
  day_position: number | null;
  is_deload: boolean | null;
  status: string | null;
  note: string | null;
  coach_workouts: WeekWorkout;
};

export type WeekWorkout = {
  id: string | null;
  name: string;
  description: string | null;
  kind: string | null;
  coach_workout_sections: WeekSection[];
};

export type WeekSection = {
  position: number | null;
  name: string | null;
  section_type: string | null;
  format: string | null;
  format_config: Record<string, unknown> | null;
  description: string | null;
  coach_workout_exercises: WeekExercise[];
};

export type WeekExercise = {
  id: string | null;
  position: number | null;
  exercise_id: string | null;
  name: string;
  tracking_fields: string[] | null;
  sets: number | null;
  reps_min: number | null;
  reps_max: number | null;
  hold_seconds_min: number | null;
  hold_seconds_max: number | null;
  rest_seconds: number | null;
  tempo: string | null;
  notes: string | null;
  each_side: boolean | null;
  superset_with_next: boolean | null;
  hold_until_lost: boolean | null;
  coach_workout_sets: WeekSet[];
};

export type WeekSet = {
  position: number | null;
  set_type: string | null;
  reps: number | null;
  weight_kg: number | null;
  time_seconds: number | null;
  rounds: number | null;
  distance_m: number | null;
  rest_seconds: number | null;
};

/** A whole week: `reviewer_week(client, monday, monday + 6)` and `reviewer_week_proposals.week`. */
export type WeekTree = WeekDay[];
